// extracted by mini-css-extract-plugin
module.exports = {"status":"PaymentStatus_status__FpSru","icon":"PaymentStatus_icon__DI6LX","info":"PaymentStatus_info__oEZY4","error":"PaymentStatus_error__8fVxs","link":"PaymentStatus_link__K2x5L"};